import {takeLatest, put, call} from 'redux-saga/effects';
import apiCall from '../../api';
import {DELETE_MANAGEMENT_ERROR, DELETE_MANAGEMENT_START, DELETE_MANAGEMENT_SUCCESS} from "../../types";

export function* deleteManagement({payload}) {
    try {
        const url = `/management/${payload.id}/`;
        const method = 'DELETE';
        const headers = {Authorization: 'Bearer ' + payload.token, 'Content-Type':'application/json'};
        const results = yield call(apiCall, url, method, payload.formData, headers);
        yield put({type: DELETE_MANAGEMENT_SUCCESS, results: results.data});
        yield put(payload.navigate('/app/management-data'));
    } catch (error) {
        yield put({type: DELETE_MANAGEMENT_ERROR, error});
    }
}

export default function* delete_management() {
    yield takeLatest(DELETE_MANAGEMENT_START, deleteManagement);
}